import cx from 'classnames';
import React from 'react';
import { CheckboxItem, Input } from "../../atoms";
import Chip from "../../atoms/Chip";
import ContextMenu from '../ContextMenu';
import RepeaterList from "../List/RepeaterList";
import Popover from "../Popover";
import styles from './ChipInput.module.scss';
import usePresenter from './ChipInput.presenter';
import { ChipInputProps, OptionLike } from "./ChipInput.types";
// import { onEnterKeyPreventFormSubmit } from './ChipInput.utils';

const ChipInput = <T extends string[] | OptionLike[]>(props: ChipInputProps<T>) => {
  const {
    handleChipInputAreaClick,
    chips,
    handleKeyDown,
    inputValue,
    onValueChange,
    inputRef,
    optionList,
    variantProps,
    disabled,
  } = usePresenter(props);

  return (
    <Popover
      className={cx(styles.popover, styles.chipInput)}
      target={
        <div
          className={cx(
            styles.trigger,
            styles.chipList,
            props.className,
          )}
          onClick={handleChipInputAreaClick}
        >
          <RepeaterList
            data={chips}
            component={Chip}
          />
          <Input
            ref={inputRef}
            id={props.id}
            className={cx(styles.input, {
              [styles.disabledInput]: disabled,
            })}
            placeholder={props.placeholder}
            required={props.required}
            invalid={props.invalid}
            onKeyDown={handleKeyDown}
            value={inputValue}
            onValueChange={onValueChange}
            disabled={disabled}
          />
        </div>
      }
      content={
        <ContextMenu
          data={optionList}
          component={CheckboxItem}
          className={styles.contextMenu}
        />
      }
      direction='Down'
      alignment='Start'
      action='Click'
      hideOnClickAway={true}
      keepContentOnItemClick={true}
      offset={[0, 2]}
      disabled={disabled}
      {...variantProps}
    />
  );
};

export default ChipInput;
